<router-outlet></router-outlet>
<p-confirmDialog [style]="{'min-width': '30vw'}" [styleClass]="options?.className"></p-confirmDialog>
<p-confirmPopup key="confirmPopUp" ></p-confirmPopup>